import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2edb2084"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "descriptions" }
const _hoisted_2 = { class: "div" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "div" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Collapse = _resolveComponent("Collapse")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, i) => {
        return (_openBlock(), _createElementBlock("li", { key: i }, [
          _createElementVNode("div", _hoisted_2, [
            _createTextVNode(_toDisplayString(item.title) + " ", 1),
            (item.new)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.newimg,
                  alt: ""
                }, null, 8, _hoisted_3))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_4, [
            (item.collapse)
              ? (_openBlock(), _createBlock(_component_Collapse, {
                  key: 0,
                  sign: item.key,
                  lineclamp: 6,
                  content: item.content || (_ctx.info || {})[item.key] || '—'
                }, null, 8, ["sign", "content"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (item.key === 'Website' && (_ctx.info || {})[item.key])
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: "javascript:;",
                        onClick: ($event: any) => (_ctx.gotolink((_ctx.info || {})[item.key] || ''))
                      }, _toDisplayString(item.content || (_ctx.info || {})[item.key] || '—'), 9, _hoisted_6))
                    : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(item.content || (_ctx.info || {})[item.key] || '—'), 1))
                ]))
          ]),
          (item.remarks)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(item.remarks), 1))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}